import React, { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import ObjectViewLayout from '@/components/layouts/ObjectViewLayout';
import { usePipelineContext } from '@/context/pipelineContext';
import { useObjectContext } from '@/hooks/useObjectContext';
import { AddProposalDocumentDialog } from '@/components/dialogs/AddProposalDocumentDialog';
import { FolioErrorBoundary } from '@/components/layouts/FolioErrorBoundary';
import { DealTabView } from './DealTabView';
import { DealAboutCard } from './DealAboutCard';
import { DealDialogs } from './DealDialogs';

const DealViewWrapper = () => {
	const { pathname, state } = useLocation();
	const navigate = useNavigate();
	const { dealId } = useParams();
	const { dealRow } = useObjectContext();
	const { pipeline } = usePipelineContext(dealRow?.pipeline);

	useEffect(() => {
		if (pipeline?.url && !pathname.startsWith(pipeline?.url)) {
			const remainder = pathname.split(dealId).slice(-1);
			navigate(`${pipeline?.url}/${dealId}${remainder?.[0] ?? ''}`, { replace: true, state });
		}
	}, [pathname, dealId, pipeline]);

	return (
		<ObjectViewLayout
			tabView={<DealTabView />}
			aboutCard={
				<FolioErrorBoundary
					dealId={dealId}
					key={`${dealId}-${pipeline}`}
					scope={pipeline}
					message='Error loading content'
					context='DealViewWrapper'
				>
					<DealAboutCard />
				</FolioErrorBoundary>
			}
		>
			<DealDialogs />
			<AddProposalDocumentDialog documentType={'WYTU'} />
			<AddProposalDocumentDialog documentType={'Quote'} />
		</ObjectViewLayout>
	);
};

DealViewWrapper.displayName = 'DealViewWrapper';

export default DealViewWrapper;
